import application from 'application/application';

import template from './movements-details.template.html';

import controller from './movements-details.controller';

application.config([
	'$stateProvider',
	$stateProvider => {
		$stateProvider
			.state('root.default.movements.list1.movementsDetails', {
				url: '/detalhes/:movementsID/:type/:movementsIDs?print',
				views: {
					'movements@root.default.movements': {
						templateUrl: template,
						controller
					}
				}
			})
			.state('root.default.movements.list2.movementsDetails', {
				url: '/detalhes/:movementsID/:type/:movementsIDs?print',
				views: {
					'movements@root.default.movements': {
						templateUrl: template,
						controller
					}
				}
			})
			.state('root.default.movements.list3.movementsDetails', {
				url: '/detalhes/:movementsID/:type/:movementsIDs?print',
				views: {
					'movements@root.default.movements': {
						templateUrl: template,
						controller
					}
				}
			})
			.state('root.default.movements.list4.movementsDetails', {
				url: '/detalhes/:movementsID/:type/:movementsIDs?print',
				views: {
					'movements@root.default.movements': {
						templateUrl: template,
						controller
					}
				}
			});
	}
]);
